import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchConversationData,
  fetchProfileData,
  fetchUserData,
} from "../../features/chat/chatSlice";

import { BiArrowBack } from "react-icons/bi";
import "../../assets/css/chat.css";
import "../../assets/css/chat-header.css";
import "../../assets/css/chat-view.css";
import "../../assets/css/message-input.css";
import "../../assets/css/user-container.css";
import "../../assets/css/circular-progress-bar.css";

import UserCard from "../../components/chat/UserCard";
import Profile from "../../components/chat/Profile";
import Conversation from "../../components/chat/Conversation";



export default function Chat() {
  const userId = useParams()?.id;
  const { userData } = useSelector(
    (state) => state.chat
  );

  let navigate = useNavigate();

  const dispatch = useDispatch();

  const fetchConversation = async () => {
    const res = await dispatch(fetchProfileData()).unwrap();
    dispatch(
      fetchConversationData({
        profileId: res?.data?.body?.user?.AccountId,
        userId: userId,
      })
    );
  }

  useEffect(() => {
    dispatch(fetchUserData(userId));
    fetchConversation();    
  }, []);

  return (
    <div className="messaging-main">
      <div className="messaging-go-back" onClick={() => navigate(-1)}>
        <BiArrowBack fontSize="1.25rem" />
        Go back to Manage Candidate
      </div>
      <div className="messaging-userprofile-container">
        <div className="messaging-container-main">
          <Profile userData={userData} />
          <div className="chatContainer">
            <Conversation />
          </div>
        </div>
        <UserCard userData={userData} />
      </div>
    </div>
  );
}
